<script lang="ts">
  import { createContext } from 'reka-ui'
  import { ref, type Ref } from 'vue'
  import globalSearchDialog from './global-search-dialog.vue'
  import RecentSearchProvider from '../recent-search/recent-search-provider.vue'
  export interface GlobalSearchCommandContext {
    openSearchCommand: () => void
    closeSearchCommand: () => void
    isSearchCommandOpen: Ref<boolean>
  }

  const [_useGlobalSearchCommand, provideGlobalSearchCommand] =
    createContext<GlobalSearchCommandContext>('gs-global-search')

  export function useGlobalSearchDialog(): GlobalSearchCommandContext {
    try {
      return _useGlobalSearchCommand()
    } catch (error) {
      console.error('Global search context not found')
      return {
        openSearchCommand: () => {},
        closeSearchCommand: () => {},
        isSearchCommandOpen: ref(false)
      }
    }
  }
</script>

<script setup lang="ts">
  import { onBeforeUnmount, onMounted } from 'vue'

  const isOpen = ref(false)

  const openSearchCommand = () => {
    isOpen.value = true
  }

  const closeSearchCommand = () => {
    isOpen.value = false
  }

  provideGlobalSearchCommand({
    openSearchCommand,
    closeSearchCommand,
    isSearchCommandOpen: isOpen
  })

  const handleGlobalShortcut = (event: KeyboardEvent) => {
    if (event.ctrlKey && event.key.toLowerCase() === 'k') {
      event.preventDefault()
      openSearchCommand()
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleGlobalShortcut)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleGlobalShortcut)
  })
</script>

<template>
  <recent-search-provider>
    <slot />
    <global-search-dialog v-model:open="isOpen" />
  </recent-search-provider>
</template>
